import { render, staticRenderFns } from "./DatosTable.vue?vue&type=template&id=3275860e"
import script from "./DatosTable.vue?vue&type=script&lang=js"
export * from "./DatosTable.vue?vue&type=script&lang=js"
import style0 from "./DatosTable.vue?vue&type=style&index=0&id=3275860e&prod&lang=css"
import style1 from "./DatosTable.vue?vue&type=style&index=1&id=3275860e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports